import { ProductionManagementPage } from "./ProductionManagementPage";
import { ProductionManagementProvider } from "./context/ProductionManagementContext";

const ProductionManagement = () => {
	return (
		<ProductionManagementProvider>
			<ProductionManagementPage />
		</ProductionManagementProvider>
	);
};

export default ProductionManagement;
